
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claim",
      function () {
        return require("private-next-pages/claim.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claim"])
      });
    }
  